import { createHexId } from '../support/createHexId';
import DataStore from '../support/DataStore';
import { Addon } from '../types/shared/Addon';

const dataStore = DataStore.getInstance('app');

function saveAddon(newAddon: Addon) {
  let addons = dataStore.get('addons') || new Map();
  addons.set(newAddon.id, newAddon);
  dataStore.set('addons', addons);
}

class AddonActions {
  static saveAddon(addon: Addon) {
    saveAddon(addon);
  }

  static saveAddons(addons: Array<Addon> | undefined) {
    dataStore.set('addons', new Map(addons?.map((addon) => [addon.id, addon])));
  }

  static addAddon(): Addon {
    let now = new Date().toISOString();
    let newAddon: Addon = {
      id: createHexId(),
      name: '',
      defaultPrice: 0,
      created_at: now,
      modified_at: now,
    };
    saveAddon(newAddon);
    return newAddon;
  }

  static deleteAddon(addon: Addon | null | undefined) {
    let addons = dataStore.get('addons');
    if (!addon || !addons) {
      return;
    }
    if (addons.has(addon.id)) {
      addons.delete(addon.id);
      dataStore.set('addons', addons);
    }
  }
}

export default AddonActions;
